import state from "../state"

const getters = {
    loginUrlGetter(state) {
        console.log('state.jumpUrl', state.jumpUrl)
        return state.jumpUrl
    },
    dialogDataGetter(state) {
        return state.dialogData
    },
    dialogTypeGetters(state) {
        return state.dialogType
    },
    // 全局loading
    fullscreenLoadingGetters(state) {
        return state.fullscreenLoading
    },
    loginGetters(state) {
        return state.login
    },
    joinGetters(state) {
        return state.join
    },
    stepDataGetters(state) {
        return state.stepData
    },
    userInfoGetters(state) {
        return state.userInfo
    },
    // 搜索条件
    searchConditionGetters(state) {
        return state.searchCondition
    },
    searchValGetters(state) {
        return state.searchVal
    },
    // 获取列表
    listGetters(state) {
        return state.list
    },
    // 是否重置
    isResetGetters(state) {
        return state.isReset
    },
    // 分页条件
    pageInfoGetters(state) {
        return state.pageInfo
    },
    // 登录状态
    loginInfoGetters(state) {
        return state.loginInfo
    }
}
export default getters
